import { useTranslation } from "react-i18next";
import { BsCoin } from "react-icons/bs";
import { GiAlarmClock, GiCoins, GiCrownCoin } from "react-icons/gi";
import {
  MdCurrencyFranc,
  MdDashboard,
  MdMoving,
  MdPercent,
  MdSupervisedUserCircle,
  MdVideoLibrary,
} from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { SiBloglovin } from "react-icons/si";
import { UseAuth } from "src/auth/AuthContext";
import { getProfileDefaultImage, validateRouteRole } from "src/helpers/mixins";
import ImgKing from "src/assets/images/king.png";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaCommentDots,
  FaIdCard,
  FaLaptop,
  FaUserTie,
  FaUsers,
} from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { TbCurrencyPeso } from "react-icons/tb";
import { BiLogOut, BiVideo } from "react-icons/bi";
const SideBarAdmin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = UseAuth();
  const location = useLocation();
  let { pathname } = location;
  const role = user?.role || "user";
  const enableRoutes = validateRouteRole(role);

  useEffect(() => {
    //if(!enableRoutes.includes(pathname)){
    /*     console.log("enable Routes es ", enableRoutes);
    console.log("pathname ", pathname);
 */
    if (pathname.includes("detalle/") && user?.role === "cajerobolivares") {
      const find = pathname.indexOf("/detalle/");
      console.log("find", find);
      pathname = pathname.substring(0, find + 8);
      console.log("nuevo pathname", pathname);
    }
    if (!enableRoutes.includes(pathname) && user?.role === "cajerobolivares") {
      navigate("/admin");
    }
  }, [pathname]);

  return (
    <div
      className="sidebar fixed text-xs pt-2 text-black opensans px-8"
      style={{ width: "17rem" }}
    >
      <div className="justify-center bg-stone-100 flex items-center gap-2 flex mt-7 font-normal mb-2 relative z-1">
        <div className="relative">
          <img
            src={ImgKing}
            alt="user"
            className="w-7 z-10 right-1.5 -top-6 absolute"
          />
          <div
            className="w-10 h-10 bg-cover bg-center rounded-full"
            onClick={() => navigate(`/usuario/${user?.id}`)}
            style={{
              backgroundImage: `url(${
                (user?.photoUrl?.length || 0) > 0
                  ? process.env.REACT_APP_PROFILEPICTURE +
                    (user?.photoUrl || "")
                  : getProfileDefaultImage()
              })`,
            }}
          ></div>
        </div>
        <div
          onClick={() => navigate(`/usuario/${user?.id}`)}
          className="ellipsis font-medium cursor-pointer hover:underline"
        >
          {user?.fullname}
        </div>
      </div>
      <ul className="mt-1 bg-white rounded-md shadow-sm border border-stone-200">
        {(enableRoutes.includes("*") || enableRoutes.includes("/admin")) && (
          <li className="flex flex-row hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin"
              >
                <MdDashboard size={13} className="mr-2 text-black" /> Dashboard
              </Link>
            </div>
          </li>
        )}
        {(enableRoutes.includes("*") || enableRoutes.includes("/admin")) && (
          <li className="flex flex-row hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/cashier"
              >
                <FaUserTie size={13} className="mr-2 text-black" /> Cajeros
              </Link>
            </div>
          </li>
        )}
        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/coins")) && (
          <li className="flex flex-row hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/coins"
              >
                <BsCoin size={13} className="mr-2 text-black" /> Coins casa
              </Link>
            </div>
          </li>
        )}
        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/depositos")) && (
          <li className="flex flex-row hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/depositos"
              >
                <FaMoneyBillTransfer size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.deposits")}
              </Link>
            </div>
          </li>
        )}
        {/*(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/depositos-bolivares")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/depositos-bolivares"
              >
                <SiCashapp size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.depositsbolivares")}
              </Link>
            </div>
          </li>
        )*/}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/solicitud-coins")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/solicitud-coins"
              >
                <GiCrownCoin size={13} className="mr-2 text-black" /> Transferir
                Coins
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/cuentas-pago-coins")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/cuenta-pago-coins"
              >
                <GiCoins size={13} className="mr-2 text-black" /> Cuenta pago
                coins
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/usuario/lista")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/usuario/lista"
              >
                <FaUsers size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.users")}
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/fee-de-ganancia")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/fee-de-ganancia"
              >
                <MdPercent size={13} className="mr-2 text-black" /> Fee de
                ganancia
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/fiat")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/fiat"
              >
                <MdCurrencyFranc size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.fiat")}
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/procesadores")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/procesadores"
              >
                <TbCurrencyPeso size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.process")}
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/verificaciones")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/verificaciones"
              >
                <FaIdCard size={13} className="mr-2 text-black" /> KYC
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/transferencias/opiniones")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/transferencias/opiniones"
              >
                <FaCommentDots size={13} className="mr-2 text-black" />{" "}
                Opiniones
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/depositos/tiempo")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/depositos/tiempo"
              >
                <GiAlarmClock size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.deposittime")}
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/roles")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/roles"
              >
                <MdSupervisedUserCircle size={13} className="mr-2 text-black" />{" "}
                {t("sidebar.roles")}
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/blog")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/blog"
              >
                <SiBloglovin size={12} className="mr-2 text-black" />{" "}
                {t("sidebar.blog")}
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/videos")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/videos"
              >
                <BiVideo size={14} className="mr-2 text-black" /> {t("Video")}
              </Link>
            </div>
          </li>
        )}
        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/videos")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/videos/promocional"
              >
                <MdVideoLibrary size={14} className="mr-2 text-black" />{" "}
                {t("Video")} promocional
              </Link>
            </div>
          </li>
        )}

        {(enableRoutes.includes("*") ||
          enableRoutes.includes("/admin/weltrade")) && (
          <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
            <div className="flex items-center text-xs">
              <Link
                className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
                to="/admin/weltrade"
              >
                <MdMoving size={14} className="mr-2 text-black" />{" "}
                Weltrade
              </Link>
            </div>
          </li>
        )}

        <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
          <div className="flex items-center text-xs">
            <Link
              className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
              to="/salir"
            >
              <BiLogOut size={13} className="mr-2 text-black" /> {t("exit")}
            </Link>
          </div>
        </li>

        {/*         <li className="flex flex-row  hover:bg-stone-200  transition-all justify-start items-center">
          <div className="flex items-center text-xs">
            <Link
              className="flex flex-row text-stone-700 font-normal items-center py-2 px-3 hover:text-black"
              to="/inicio"
            >
              <FaLaptop size={13} className="mr-2 text-black" /> {t("website")}
            </Link>
          </div>
        </li> */}
      </ul>
    </div>
  );
};
export default SideBarAdmin;
